import '../App.css';
import './SideNav.css';
import { Section } from './Section';
import { SideNav } from './SideNav';
import { Tab } from './Tab';
import { useContext } from 'react';
import { DataContext } from '../services/dataContext';

export function Page({ id }) {
  const data = useContext(DataContext);
  
  function getSectionName() { 
    return getPageData()?.name ;
  }

  function getPageData() { 
    return data.pages.find((el) => el.id === id);
  }

  function getJobsCoverage() { 
    let total = 0;
    let withProofs = 0;
    getPageData()?.levels.forEach((level) => {
      total += level.jobs.length;
      withProofs += level.jobs.filter((job) => job.proofs.length).length;
    })
    return ` (${withProofs} / ${total})`;
  }

  return (
    <>
      <SideNav />
      <div id="main" className="App">
        <header className="App-header">
          <Section
            name={`${getSectionName() + getJobsCoverage()}`}
          />
        </header>
        <Tab data={getPageData()} />
      </div>
    </>
  );
}

export default Page;
